function findTree (arr, value) {
  let result = []
  function find (arr, value) {
    arr.forEach(item => {
      // 判断递归结束条件
      if (item.menuLevel == value || item.pageUrl) {
        // 存储数据到空数组
        result.push(item)
      } else if (item.childMenu != null) {
        // 判断chlidren是否有数据
        // 递归调用
        find(item.childMenu, value)
      }
    })
  }
  find(arr, value)

  return result
}

function getFloorTree (treeData) {
  let result = []
  function find (treeData) {
    treeData.forEach(item => {
      if (item.childTree) {
        find(item.childTree)
      } else {
        result.push(item.id)
      }
    })
  }
  find(treeData)
  return result
}

function getTreeFunc (arr1, arr2) {
  let result = []
  arr1.forEach(item => {
    if (arr2.includes(item)) {
      result.push(item)
    }
  })
  return result
}

export default {
  findTree,
  getTreeFunc,
  getFloorTree
}
